var React = require('react');

function FlagGb (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"25","height":"15","fill":"#00247d","key":0}),React.createElement("path",{"d":"M 0,0 L 25,15 M 25,0 L 0,15","stroke":"#fff","strokeWidth":"3","key":1}),React.createElement("path",{"d":"M 12.5,0 V 15 M 0,7.5 H 25","stroke":"#fff","strokeWidth":"5","key":2}),React.createElement("path",{"d":"M 12.5,0 V 15 M 0,7.5 H 25","stroke":"#cf142b","strokeWidth":"3","key":3})]);
}

FlagGb.defaultProps = {"viewBox":"0,0 25,15"};

module.exports = FlagGb;

FlagGb.default = FlagGb;
